// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ProductImageLoadingSpinner_spinner__7Oj88","spin":"ProductImageLoadingSpinner_spin__g1B6I","imageOnTopStyle":"ProductImageLoadingSpinner_imageOnTopStyle__RYNEu"};